//
import React from 'react'

/* $FlowFixMe */
const DropdownContext = React.createContext({
    close: () => {},
})

export default DropdownContext
